var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrograms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.99315 3.02644C2.57932 2.81482 3 2.2365 3 1.55625C3 0.696757 2.32843 0 1.5 0C0.671573 0 0 0.696757 0 1.55625C0 2.2365 0.420678 2.81482 1.00685 3.02644C1.00234 3.05443 1 3.08318 1 3.1125V16.0813C1 16.3677 1.22386 16.6 1.5 16.6C1.77614 16.6 2 16.3677 2 16.0813V3.1125C2 3.08318 1.99766 3.05443 1.99315 3.02644ZM3 3.43938C3 3.23964 3.11006 3.05812 3.28698 2.97935C3.91594 2.69931 5.46251 2.075 6.75 2.075C8.36051 2.075 10.3764 3.05188 10.4946 3.10982C10.4984 3.11169 10.5014 3.11313 10.5052 3.11491C10.625 3.16998 12.7769 4.15 14.25 4.15C15.2269 4.15 16.5023 3.71899 17.2857 3.41258C17.6248 3.27994 18 3.53703 18 3.913V11.0732C18 11.2793 17.8826 11.4656 17.6983 11.5423C17.0293 11.8206 15.3906 12.45 14.25 12.45C12.834 12.45 10.6504 11.48 10.5074 11.4158C10.5022 11.4135 10.4979 11.4115 10.4928 11.409C10.3582 11.3431 8.35324 10.375 6.75 10.375C5.70406 10.375 4.48712 10.787 3.7301 11.0918C3.38712 11.2298 3 10.971 3 10.5893V3.43938Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrograms);
export default __webpack_public_path__ + "static/media/Programs.7cb5f0e7f2b996c9a939b3f75147ff49.svg";
export { ForwardRef as ReactComponent };